import { Outlet } from "@tanstack/react-router";

import { useClarityIdentifier } from "@/hooks/useClarityIdentifier";
import { useClarityPageType } from "@/hooks/useClarityPageType";
import { useContentsquareIdentifier } from "@/hooks/useContentsquareIdentifier";
import { useMixpanelIdentifier } from "@/hooks/useMixpanelIdentifier";
import { useAuthInterceptor } from "@/providers/auth/useAuthInterceptor";

export const RootLayout = () => {
  useAuthInterceptor();
  useContentsquareIdentifier();
  useClarityIdentifier();
  useClarityPageType();
  useMixpanelIdentifier();

  return (
    <>
      <Outlet />
    </>
  );
};
